import { differenceInDays } from 'date-fns';

function diffWeeksDays(dateLeft, dateRight) {
    const days = differenceInDays(dateLeft, dateRight);
    return { weeks: Math.floor(days / 7), days: days % 7 };
}

export { diffWeeksDays };
export default diffWeeksDays;
